module.exports = __webpack_public_path__ + "static/media/sh_1.f874ef88.mp3";